import { render } from "./legoToast.vue?vue&type=template&id=73e50326"
import script from "./legoToast.vue?vue&type=script&lang=js"
export * from "./legoToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoToast/legoToast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73e50326"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73e50326', __exports__)) {
    api.reload('73e50326', __exports__)
  }
  
  module.hot.accept("./legoToast.vue?vue&type=template&id=73e50326", () => {
    api.rerender('73e50326', render)
  })

}


export default __exports__